export default __webpack_public_path__ + "static/media/i048hp.0e3a214d.webp";